export default "/assets/images/sock.webp?d01692a75cdbe1eaa5abe519835eb241";